<app-dialog-header
  [header]="'library.user_card.dialog.send_message.header' | translate"
  iconClass="icon-send-msg-device-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid p-align-center">
    <div class="p-col-12">
      <label
        for="enable-lost-mode-message"
        class="send-message-label"
      >
        {{ 'library.user_card.dialog.send_message.enter_message' | translate }}:
      </label>
      <app-wysiwyg
        id="enable-lost-mode-message"
        [appSuggestions]="['USER', 'ACTIVE_DIRECTORY', 'DEVICE']"
        [config]="wysiwygConfig"
        formControlName="message"
      ></app-wysiwyg>
      <app-input-length-counter
        [control]="form?.get('message')"
        [maxLength]="MAX_MESSAGE_LENGTH"
      ></app-input-length-counter>
      <app-form-control-error [control]="form.get('message')"></app-form-control-error>
    </div>
    <div class="p-col-12">
      <app-checkbox
        [label]="'library.user_card.dialog.send_message.audible' | translate"
        binary="true"
        data-qa="audible"
        formControlName="audible"
      >
      </app-checkbox>
    </div>
    <div class="p-col-12">
      <app-checkbox
        [label]="'library.user_card.dialog.send_message.vibrate' | translate"
        binary="true"
        data-qa="vibrate"
        formControlName="vibrate"
      >
      </app-checkbox>
    </div>
    <div [hidden]="!isDialogAllowed">
      <div class="p-col-12">
        <app-checkbox
          [label]="'library.user_card.dialog.send_message.dialog' | translate"
          binary="true"
          data-qa="has-dialog"
          formControlName="hasDialog"
        >
        </app-checkbox>
      </div>
      <div class="p-col-12">
        <label
          for="time-to-read"
          class="send-message-label"
        >
          {{ 'library.user_card.dialog.send_message.time_to_read.label' | translate }}:
        </label>
        <app-tooltip-icon [appTooltip]="'library.user_card.dialog.send_message.time_to_read.tooltip' | translate: { min: TimeToReadRange.MIN, max: TimeToReadRange.MAX }"></app-tooltip-icon>
        <input
          id="time-to-read"
          autocomplete="off"
          data-qa="time-to-read"
          formControlName="timeToRead"
          appInput
          type="text"
        >
        <app-form-control-error [control]="form.get('timeToRead')"></app-form-control-error>
      </div>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="send-message-dialog-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [submitButton]="form"
    (click)="submit(form)"
    data-qa="send-message-dialog-submit-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.send.label' | translate }}
  </button>
</div>
